import { memberKind, type MemberKind } from "~/lib/member-kind";

const LABELS: Record<Exclude<MemberKind, "human">, string> = {
  agent: "Agent",
  app: "App",
};

export interface MemberKindBadgeProps {
  userId: string;
}

export function MemberKindBadge({ userId }: MemberKindBadgeProps) {
  const kind = memberKind(userId);
  if (kind === "human") return null;
  const label = LABELS[kind];
  return (
    <span
      aria-label={label}
      style={{
        display: "inline-flex",
        flexShrink: 0,
        color: "var(--chat-fg-muted)",
        fontFamily: "var(--chat-font-sans)",
        fontSize: 10,
        lineHeight: "var(--chat-type-body-xs-line)",
        letterSpacing: "0.1em",
        textTransform: "uppercase",
      }}
    >
      {label}
    </span>
  );
}
